// eslint-disable-next-line
import React from 'react';
import DataSheetBase from './DataSheetBase.js';

export default class DataSheet_pricesIndeLiving2bdrm extends DataSheetBase {

}
